module.exports = __webpack_public_path__ + "img/expovina-primavera_01.411ad2d8.jpg";